const myRecords= {
   record1: { id: 1, name: "BB King Live", category: "Blues", 
        description: "Live at the Regal 1965", price: 1275, image: "/BBking.jpg" },
   record2: { id: 2, name: "Howlin' Wolf BBC Sessions", category: "Blues", 
        description: "Recorded Live at BBC Studios", price: 1895, image: "/HowlinWolf.jpg" },
   record3: { id: 3, name: "Exile on Main St.", category: "Rock", 
        description: "Studio album by The Rolling Stones", price: 1950, image: "/RollingStones.jpg" },
    record4: { id: 4, name: "Led Zeppelin I", category: "Rock", 
        description: "Studio Album by Led Zeppelin", 
        price: 3495, image: "/LedZep.jpg" },
    record5:{ id: 5, name: "Dark Side of The Moon", category: "Rock", 
        description: "Studio album by Pink Floyd", price: 2500, image:"/PinkFloyd.jpg" },
    record6:{ id: 6, name: "Revolver", category: "Pop", 
        description: "Studio album by The Beatles", price: 1675, image:"/Revolver.jpg" },
    record7:{ id: 7, name: "Help!", category: "Pop", 
        description: "Studio album by The Beatles", 
        price: 2995, image:"/Help.jpg" },
    record8:{ id: 8, name: "Tusk", category: "Pop", 
        description: "Studio Album by Fleetwood Mac", price: 3075, image:"/Tusk.jpg" },
    record9: { id: 9, name: "If You Can Belive Your Eyes And Ears", category: "Pop", 
        description: "Studio album by The Mammas and The Papas", price: 2200, image:"/Mamas.jpg" }
}

export default myRecords;